/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
window.Vue = require('vue');
window.introJs = require('intro.js');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import { Lang } from 'laravel-vue-lang';

Vue.use(Lang, {
    fallback: 'en'
})

Vue.component('newproject-form', require('./components/NewProjectForm.vue').default);
Vue.component('recap-table', require('./components/manager/RecapTable.vue').default);
Vue.component('prohome-form', require('./components/pro/ProHome.vue').default);
Vue.component('companyopen-form', require('./components/pro/CompanyOpen.vue').default);
Vue.component('myprojects-form', require('./components/pro/MyProjects.vue').default);
Vue.component('individualopen-form', require('./components/pro/IndividualOpen.vue').default);
Vue.component('beneficiaries-form', require('./components/pro/Beneficiary.vue').default);

Vue.component('super-beneficiaries-form', require('./components/super_pro/Beneficiary.vue').default);
Vue.component('super-projects-form', require('./components/super_pro/Projects.vue').default);
Vue.component('countries-presence-form', require('./components/super_pro/CountriesPresenceForm.vue').default);

Vue.component('managerhome-form', require('./components/manager/ManagerHome.vue').default);
Vue.component('allprojects-form', require('./components/manager/AllProjects.vue').default);
Vue.component('allusers-form', require('./components/manager/AllUsers.vue').default);
Vue.component('countryuser-form', require('./components/manager/CountryUserForm.vue').default);
Vue.component('countryuserselect-form', require('./components/manager/CountryUserSelectForm.vue').default);
Vue.component('documentsmanager-form', require('./components/manager/DocumentsManager.vue').default);
Vue.component('pointcontacts-form', require('./components/manager/PointContacts.vue').default);
Vue.component('pointcontactscountry-form', require('./components/manager/PointContactsCountry.vue').default);
Vue.component('allusers-country-form', require('./components/manager/AllUsersCountryForm.vue').default);
Vue.component('allusers-country-form2', require('./components/manager/AllUsersCountryForm2.vue').default);
Vue.component('allprojects-country-form', require('./components/manager/AllProjectsCountryForm.vue').default);
Vue.component('allinvoices-country-form', require('./components/manager/AllInvoicesCountryForm.vue').default);
Vue.component('manage_hq', require('./components/super_pro/manageHQ.vue').default);

Vue.component('upload-form', require('./components/document/UploadForm.vue').default);
Vue.component('test1', require('./components/test/Test1.vue').default);
Vue.component('test2', require('./components/test/Test2.vue').default);

Vue.component('uploadcreditnote', require('./components/finance/Creditnote.vue').default);
Vue.component('uploadinvoices', require('./components/finance/Invoices.vue').default);
Vue.component('uploadquatation', require('./components/finance/Qautation.vue').default);

Vue.component('africa-map', require('./components/AfricaMap.vue').default);
Vue.component('business-directory-form', require('./components/BusinessDirectoryForm.vue').default);

// LANDING
Vue.component('landing-blog-post', require('./components/landing/BlogPost.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
    el: '#app',
});
window.AOS = require('aos');
window.addEventListener('load', AOS.refresh)
AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

Vue.use(require('bootstrap-vue'));
